import React, { FC } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import { Container, StyledChip } from './styles';
import { IAppState } from '../../../../state/reducers';
import {
  IProps,
  IStateProps,
  IDispatchProps,
} from './interfaces';
import {
  toggleTeamSelection,
  selectSelectedTeams,
  toggleTeamFocus,
} from '../../../../state/exchange/searchParams';

const ExchangeSelectedTeams: FC<IProps> = (props: IProps) => {
  const {
    selectedTeams,
    onTeamDelete,
    onTeamFocus,
  } = props;

  return (
    <Container>
      {selectedTeams.length === 0 && (
        <StyledChip
          label="No Teams Selected"
        />
      )}
      {selectedTeams.length > 0 && _.sortBy(selectedTeams, ['teamName']).map(({
        teamName,
        teamIndex,
        conferenceIndex,
        isFocused,
        conferenceName,
        teamId,
      }) => (
        <StyledChip
          label={teamName}
          key={teamName}
          className={isFocused ? 'focused' : ''}
          onClick={() => onTeamFocus(conferenceIndex, teamIndex)}
          onDelete={() => onTeamDelete(conferenceName, teamId)}
        />
      ))}
    </Container>
  );
};

const mapStateToProps = (state: IAppState): IStateProps => ({
  selectedTeams: selectSelectedTeams(state),
});

const mapDispatchToProps: IDispatchProps = {
  onTeamDelete: toggleTeamSelection,
  onTeamFocus: toggleTeamFocus,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExchangeSelectedTeams);
